import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import { Dialog, DialogContent, DialogTitle, Stack } from '@mui/material';
import ResponsiveDialogActions from './ResponsiveDialogAction';

export default function SingleDayDialog({ open, onClose, onConfirm }) {
  const [selectedDate, setSelectedDate] = React.useState(new Date());

  const handleConfirm = () => {
    if (selectedDate) {
      onConfirm(selectedDate);
    }
  };

  const persianFontFamily =
    '"Vazirmatn", "IRANSans", "Yekan Bakh", "Tahoma", sans-serif';

  const modernInputSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: '#F8FAFC', // Light subtle background
      minHeight: '52px',
      transition: 'all 0.2s ease-in-out',
      '& fieldset': {
        borderColor: '#E2E8F0', // Clean default border
        borderWidth: '1px',
      },
      '&:hover': {
        backgroundColor: '#F1F5F9',
      },
      '&:hover fieldset': {
        borderColor: '#CBD5E1',
      },
      '&.Mui-focused': {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.12)', // Modern focus ring
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3B82F6',
        borderWidth: '1px',
      },
    },
    // Ensure the label color transitions smoothly
    '& .MuiInputLabel-root': {
      color: '#64748B',
      fontWeight: 500,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#3B82F6',
    },
    // Fixes for autocomplete inner paddings
    '& .MuiAutocomplete-inputRoot': {
      padding: '6px 12px !important',
      gap: '6px',
    },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      dir="rtl"
      PaperProps={{
        sx: {
          borderRadius: '20px',
          padding: '8px 0',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 800,
          fontSize: '1.1rem',
          color: '#0f172a',
          // fontFamily: persianFontFamily,
          // textAlign: 'right',
          borderBottom: '1px solid #f1f5f9',
          pb: 2,
          mb: 1,
        }}
      >
        ورود شمش در تاریخ خاص
      </DialogTitle>

      <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
        <DialogContent sx={{ px: 3, py: 3, overflowX: 'hidden' }}>
          <Stack spacing={4} sx={{ mt: 1, mb: 3 }}>
            <DatePicker
              label="تاریخ"
              value={selectedDate}
              onChange={newValue => setSelectedDate(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  dir: 'rtl',
                  sx: modernInputSx, // اعمال استایل مدرن
                },
                popper: {
                  sx: {
                    direction: 'rtl',
                    // --- تنظیمات دکمه‌های ماه قبل و بعد ---
                    '& .MuiPickersCalendarHeader-labelContainer': {
                      marginRight: 0,
                      marginLeft: 'auto',
                    },
                    '& .MuiPickersArrowSwitcher-root': {
                      direction: 'rtl',
                    },
                    '& .MuiPickersArrowSwitcher-root .MuiIconButton-root': {
                      transform: 'rotate(180deg)',
                    },
                    '& .MuiPickersLayout-root': {
                      direction: 'rtl',
                    },
                    // '& *': {
                    //   fontFamily: `${persianFontFamily} !important`,
                    // },
                  },
                },
              }}
            />
          </Stack>

          <ResponsiveDialogActions
            onAccept={handleConfirm}
            onReject={onClose}
            acceptText={'تایید'}
            rejectText={'انصراف'}
            acceptButtonProps={{
              sx: {
                py: 1.2,
                px: 3,
                borderRadius: '12px',
                color: '#fff',
                // fontFamily: persianFontFamily,
                fontWeight: 700,
                fontSize: '0.95rem',
                boxShadow: '0 6px 16px rgba(16, 185, 129, 0.25)',
                backgroundColor: '#10b981',
                transition: 'all 0.2s',
                '&:hover': {
                  backgroundColor: '#059669',
                  boxShadow: '0 8px 20px rgba(16, 185, 129, 0.4)',
                },
              },
            }}
            rejectButtonProps={{
              sx: {
                py: 1.2,
                px: 3,
                borderRadius: '12px',
                color: '#64748B',
                // fontFamily: persianFontFamily,
                fontWeight: 700,
                fontSize: '0.95rem',
                backgroundColor: '#F1F5F9',
                transition: 'all 0.2s',
                '&:hover': {
                  backgroundColor: '#FEE2E2',
                  color: '#E11D48',
                },
              },
            }}
          />
        </DialogContent>
      </LocalizationProvider>
    </Dialog>
  );
}
